import React from "react";
import ReactDOM from "react-dom/client";
import "styles/global.css";
import "@cjdev-internal/design-tokens/design-tokens/css/variables.css";
import { AppWithNav } from "./App";
import { AppProvider } from "context";
import { IntlProvider } from "@platform/cj-platform-navigation";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const url = new URL(window.location.href);

if (url.pathname === "/health") {
  root.render(<div>Feelin good.</div>);
} else {
  root.render(
    <React.StrictMode>
      <IntlProvider locale="en">
        <AppProvider>
          <AppWithNav />
        </AppProvider>
      </IntlProvider>
    </React.StrictMode>
  );
}
